import React from "react";
import Lottie from "lottie-react";
import loadingAnimation from "../../assets/animations/loading.json"; // ganti sesuai path kamu

const LottieLoading = ({ text = "Memproses data..." }) => {
  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
      style={{ backgroundColor: "rgba(255,255,255,0.85)", zIndex: 1055 }}
    >
      <div style={{ width: 150, height: 150 }}>
        <Lottie animationData={loadingAnimation} loop={true} />
      </div>
      <div className="fw-semibold text-secondary mt-3">{text}</div>
    </div>
  );
};

export default LottieLoading;
